import { FC, ReactNode } from 'react'
import { Box, Chip, Tooltip, Typography } from '@mui/material'
import { corDoTextoSobre } from '@/utils/nivelConsultor'
import { AVISO_NIVEL_INFORMATIVO } from '@/types/nivelConsultor'

export interface ChipNivelProps {
  nome: string
  /** `#RRGGBB` do cadastro (nenhuma cor fixa no código). */
  cor: string
  /** Com descrição, o chip ganha tooltip (descrição + aviso informativo). */
  descricao?: string | null
  /** Rótulo "inativo" — só no back-office (Q-AN10-2). */
  inativo?: boolean
  size?: 'small' | 'medium'
}

/**
 * Chip do nível do consultor (AN-10 §10): fundo na cor cadastrada, texto branco ou escuro pelo
 * maior contraste (R8) e uma borda sutil para a cor não sumir em fundo de mesma tonalidade
 * (inclusive no tema escuro). Só informativo.
 */
export const ChipNivel: FC<ChipNivelProps> = ({ nome, cor, descricao, inativo = false, size = 'small' }) => {
  const chip = (
    <Chip
      size={size}
      label={inativo ? `${nome} (inativo)` : nome}
      data-testid="chip-nivel"
      sx={{
        bgcolor: cor,
        color: corDoTextoSobre(cor),
        fontWeight: 600,
        border: '1px solid rgba(0,0,0,0.12)',
        opacity: inativo ? 0.75 : 1,
        maxWidth: 260,
      }}
    />
  )
  if (!descricao) return chip
  const titulo: ReactNode = (
    <Box sx={{ p: 0.5, maxWidth: 320 }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
        {descricao}
      </Typography>
      <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.85 }}>
        {AVISO_NIVEL_INFORMATIVO}
      </Typography>
    </Box>
  )
  return (
    <Tooltip title={titulo} arrow enterTouchDelay={0}>
      <span tabIndex={0} aria-label={`Nível ${nome}: ${descricao}`} style={{ display: 'inline-flex' }}>
        {chip}
      </span>
    </Tooltip>
  )
}

export default ChipNivel
